import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowRight } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
    const { login } = useAuth();
    const [email, setEmail] = useState("admin@signiastylettoix.com");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Welcome back, admin");
            navigate("/admin");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center px-6">
            <form onSubmit={submit} className="bg-white rounded-3xl p-8 md:p-10 max-w-md w-full border border-black/5 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.18)]" data-testid="admin-login-form">
                <Link to="/" className="font-serif text-[24px] block mb-6">
                    signiastyletto<span className="text-[#003E4D]">ix</span>
                </Link>
                <p className="eyebrow flex items-center gap-2"><Lock size={12} /> Admin Access</p>
                <h1 className="font-serif text-[32px] md:text-[40px] leading-tight mt-2">Sign in to dashboard</h1>
                <div className="mt-7 space-y-4">
                    <input
                        data-testid="admin-email"
                        type="email"
                        required
                        placeholder="admin@signiastylettoix.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="h-12 w-full px-4 rounded-xl border border-[#E5E7EB] bg-white text-[15px] focus:outline-none focus:border-[#003E4D] focus:ring-2 focus:ring-[#003E4D]/15"
                    />
                    <input
                        data-testid="admin-password"
                        type="password"
                        required
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="h-12 w-full px-4 rounded-xl border border-[#E5E7EB] bg-white text-[15px] focus:outline-none focus:border-[#003E4D] focus:ring-2 focus:ring-[#003E4D]/15"
                    />
                </div>
                <button type="submit" disabled={loading} className="btn-primary w-full justify-center mt-6" data-testid="admin-submit">
                    {loading ? "Signing in…" : "Sign in"} <ArrowRight size={16} />
                </button>
                <p className="text-[12px] text-[#9CA3AF] mt-6 leading-relaxed">
                    For HearClear administrators only. Contact ops to reset access.
                </p>
            </form>
        </div>
    );
}
